import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';





@Component({
  selector: 'app-doctyp4',
  templateUrl: './doctyp4.component.html',
  styleUrls: ['./doctyp4.component.scss']
})





export class Doctyp4Component implements OnInit {


  @Input() Document: any;
  interviews = [];
  tests = [];

  men: any;
  women: any;
  dropouts: any;
  surviver: any;
  a18901895: any;
  b19001905: any;
  pausierende: any;

    // options
    showXAxis: true;
    showYAxis: true;
    gradient: false;
    showLegend: true;
    showXAxisLabel: true;
    yAxisLabel: 'Country';
    showYAxisLabel: true;
    xAxisLabel: 'Population';

  Kontrollstudie = [];
  Verteilung = [];
  Probanden = [];
  Hauptstudie = [];

  waveColor = '#000';
  waveColorTrans = '#fff';



  // options
  colorScheme = 'air';
  view: any[] = [700, 500];
  pdf: string;





  constructor(
    private http: HttpService,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {



    if (this.Document['4_uw_interviews'] && this.Document['4_uw_interviews'] !== undefined) {
      this.Document['4_uw_interviews'].forEach(element => {
        if (element['ID']) {
          this.http.analyse(element['ID']).subscribe(analyse => {
            analyse.link = [];
            this.http.doctyp5(analyse['_id']).subscribe(doctyp5 => {
              if (doctyp5['_source']) {
                if (doctyp5['_source']['5_us_welle'] && doctyp5['_source']['5_facet_us_pseudonym_proband']) {
                  analyse.link.push(
                    doctyp5['_source']['5_facet_us_pseudonym_proband'] + '/' + doctyp5['_source']['5_us_welle'].content
                  );
                }
              }

            });
            this.interviews.push(analyse);
          });
        }
      });
    }


    console.log(this.interviews);


   // sort by content
   if (this.Document['4_uw_tests']) {
    this.Document['4_uw_tests'].sort(function(a, b) {
      const nameA = a.content.toUpperCase(); // ignore upper and lowercase
      const nameB = b.content.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
   }



  // this.interviews.sort(function(a, b) {
  //   const nameA = a.content.toUpperCase(); // ignore upper and lowercase
  //   const nameB = b.content.toUpperCase(); // ignore upper and lowercase
  //   if (nameA < nameB) {
  //     return -1;
  //   }
  //   if (nameA > nameB) {
  //     return 1;
  //   }

  //   // names must be equal
  //   return 0;
  // });


    switch (this.Document['4_uw_id']['content']) {
      case '1. Welle':
        this.waveColor = 'rgba(255, 0, 0) ';
        this.waveColorTrans = 'rgba(255, 0, 0, .2) ';
        break;
      case '2. Welle':
        this.waveColor = 'rgba(139, 0, 139) ';
        this.waveColorTrans = 'rgba(139, 0, 139, .2) ';
        break;
      case '3. Welle':
        this.waveColor = 'rgba(255,185,15) ';
        this.waveColorTrans = 'rgba(255,185,15, .2) ';
        break;
      case '4. Welle':
        this.waveColor = 'rgba(0,205,0) ';
        this.waveColorTrans = 'rgba(0,205,0, .2) ';
        break;
      case '5. Welle':
        this.waveColor = 'rgba(121,205,205) ';
        this.waveColorTrans = 'rgba(121,205,205, .2) ';
        break;
      case '6. Welle':
        this.waveColor = 'rgba(0,0,255) ';
        this.waveColorTrans = 'rgba(0,0,255, .2) ';
        break;
      case '7. Welle':
        this.waveColor = 'rgba(220, 204, 64) ';
        this.waveColorTrans = 'rgba(240,230,140, .2) ';
        break;
      case '8. Welle':
        this.waveColor = 'rgba(255,105,180) ';
        this.waveColorTrans = 'rgba(255,105,180,.2) ';
        break;
      default:
        this.waveColor = 'rgba(102,102,102) ';
        this.waveColorTrans = 'rgba(102,102,102,.2) ';
    }



    if (this.Document['4_uw_tests'] && this.Document['4_uw_tests'] !== undefined) {
      this.Document['4_uw_tests'].forEach(element => {
        if (element['ID']) {

          this.http.analyse(element['ID']).subscribe(analyse => {
            this.tests.push(analyse);
          });
        }
      });
    }

    if (this.Document['4_uw_doi']) {
      this.Document['4_uw_doi'].replace('', '');
    }

    // tslint:disable-next-line:radix
    if (this.Document['4_uw_anzahl_maenner']) {
      this.men = parseInt(this.Document['4_uw_anzahl_maenner'], 10);
    }

    if (this.Document['4_uw_anzahl_frauen']) {
      this.women = parseInt(this.Document['4_uw_anzahl_frauen'], 10);
    }

    if (this.Document['4_uw_anzahl_nonsurvivors']) {
      this.surviver = parseInt(this.Document['4_uw_anzahl_nonsurvivors'], 10);
    }

    if (this.Document['4_uw_anzahl_dropouts']) {
      this.dropouts = parseInt(this.Document['4_uw_anzahl_dropouts'], 10);
    }

    if (this.Document['4_uw_anzahl_pausierende']) {
      this.pausierende = parseInt(this.Document['4_uw_anzahl_pausierende'], 10);
    }


    if (this.Document['4_uw_anzahl_kontrollfrauen']) {
      this.a18901895 = parseInt(this.Document['4_uw_anzahl_kontrollfrauen'], 10);
    }

    if (this.Document['4_uw_anzahl_kontrollmaenner']) {
      this.b19001905 = parseInt(this.Document['4_uw_anzahl_kontrollmaenner'], 10);
    }


if ( this.a18901895 && this.b19001905) {
  this.Kontrollstudie = [
    {
      'name': 'Frauen',
      'value': this.a18901895,
    },
    {
      'name': 'Männer',
      'value': this.b19001905,
    },
  ];
}





if (this.men &&  this.women) {
  this.Hauptstudie = [
    {
      'name': 'Frauen',
      'value': this.women,
    },
    {
      'name': 'Männer',
      'value': this.men,
    },
  ];
}


if (this.surviver && this.dropouts && this.pausierende) {
  this.Probanden = [

        {
          'name': 'Verstorbene',
          'value': this.surviver,
        },
        {
          'name': 'Ausgestiegene',
          'value': this.dropouts,
        },
        {
          'name': 'Pausierende',
          'value': this.pausierende,
        }

  ];
}




if (this.Document['4_sourcename0']) {
  this.pdf = 'https://bolsa.uni-halle.de/wp-content/themes/graphy/app/assets/anhang/' + this.Document['4_sourcename0'];
 }

  }

  onSelect(event) {
    console.log(event);
  }

  link(id) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + id]));
  }

  copy2Clipboard() {
    const element = document.getElementById('copy-cit');
    element.innerHTML = element.innerText || element.textContent;

    const ta = document.createElement('textarea');
    ta.value = element.innerHTML;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);

    this.snackBar.open('In die Zwischenablage kopiert', 'schließen', {
      duration: 2000,
    });
  }

}
